/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { checkCircleFilled } from "../assets/check-circle-filled";
import { Icon, type IconBaseProps } from "../icon";

export const IconCheckCircleFilled = (props: IconBaseProps) => <Icon {...props} svg={checkCircleFilled} />;

IconCheckCircleFilled.displayName = "IconCheckCircleFilled";
